var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9769 69.3759C63.9769 69.3759 74.5 58.8275 74.5 42.7519C74.5 26.6764 63.9769 17 63.9769 17C63.9769 17 53.5 26.6764 53.5 42.7519C53.5 58.8275 63.9769 69.3759 63.9769 69.3759Z",
    fill: "#009BE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68.5V100.004",
    stroke: "#009BE5",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 111C66.7614 111 69 108.761 69 106C69 103.239 66.7614 101 64 101C61.2386 101 59 103.239 59 106C59 108.761 61.2386 111 64 111Z",
    stroke: "#009BE5",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5773 72.9358C58.5773 72.9358 47.5457 75.2668 37.3434 68.6413C27.1411 62.0159 25.337 51.3493 25.337 51.3493C25.337 51.3493 35.7961 48.6883 45.9984 55.3137C56.2007 61.9392 58.5773 72.9358 58.5773 72.9358Z",
    fill: "#009BE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5701 73.93V87.6186L52.6018 92.6173",
    stroke: "#009BE5",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 100C51.7091 100 53.5 98.2091 53.5 96C53.5 93.7909 51.7091 92 49.5 92C47.2909 92 45.5 93.7909 45.5 96C45.5 98.2091 47.2909 100 49.5 100Z",
    stroke: "#009BE5",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4227 72.9358C69.4227 72.9358 80.4543 75.2668 90.6566 68.6413C100.859 62.0159 102.663 51.3493 102.663 51.3493C102.663 51.3493 92.2039 48.6883 82.0016 55.3137C71.7993 61.9392 69.4227 72.9358 69.4227 72.9358Z",
    fill: "#009BE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4299 73.93V87.6186L75.3982 92.6173",
    stroke: "#009BE5",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 100C76.2909 100 74.5 98.2091 74.5 96C74.5 93.7909 76.2909 92 78.5 92C80.7091 92 82.5 93.7909 82.5 96C82.5 98.2091 80.7091 100 78.5 100Z",
    stroke: "#009BE5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.60636ec8e724ae45b4260165ef6de92f.svg";
export { ForwardRef as ReactComponent };